import module from 'fanconsultores/module.js'
import './styles.scss'

const lowpolyBgrConfigConfig = {
  background: ['#000000', '#0F072C', '#C84034', '#FA9732', '#FED38E'],
  textcolor: '#FFFFFF',
}

module.config(($qProvider, $urlRouterProvider, $stateProvider, $sessionProvider, lowpolyBgrConfig, $animateProvider, $translateProvider, markedProvider, $locationProvider, $httpProvider, $compileProvider, $sceDelegateProvider, ENV) => {
  $urlRouterProvider.otherwise('/')

  // Lowpoly background
  lowpolyBgrConfig.background = lowpolyBgrConfigConfig.background
  lowpolyBgrConfig.textcolor = lowpolyBgrConfigConfig.textcolor

  // Animaciones
  $animateProvider.classNameFilter(/ui-animate/)

  // Traductor
  $translateProvider.useStorage('FanSharedLanguageStorage')
  $translateProvider.useLoader('FanSharedLanguageLoader')
  $translateProvider.storageKey('lang')
  $translateProvider.useSanitizeValueStrategy('escape')

  $qProvider.errorOnUnhandledRejections(false)

  // Deprecated
  $sessionProvider.prefix = '/fanconsultores/admin'

  markedProvider.setOptions({gfm: true})

  $locationProvider.html5Mode(true)

  $httpProvider.useApplyAsync(true)

  $compileProvider.debugInfoEnabled(ENV.debugMode)

  $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|mailto|blob):/)

  $sceDelegateProvider.resourceUrlWhitelist([
    'self',
    'http://admin.fanconsultores.com/**',
  ])
})




// WEBPACK FOOTER //
// ./src/fanconsultores/config.js